import http from '@axios'

const upload = ({file}) => {
  const form = new FormData();
  form.append('image', file);
  return http.post('/upload', form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  })
}

export {upload}
